import { createUseStyles, ComposedTheme } from '@glu/theming';
import '../themeDefaults';

const styles = ({ formComponents }: ComposedTheme) => ({
  dark: {},
  error: {},
  root: {
    '&$dark': {
      color: formComponents.dark.color,
    },
    '&$error': {
      '&$dark': {
        color: formComponents.dark.error.borderColor,
      },
      color: formComponents.error.borderColor,
    },
    '&$textarea': {
      lineHeight: `${formComponents.input.textareaHeight}px`,
    },
    '&$warning$error': {
      '&$dark': {
        color: formComponents.dark.warning.borderColor,
      },
      color: formComponents.warning.borderColor,
    },
    color: formComponents.label.color,
    fontFamily: formComponents.optionalSpanFontFamily,
    fontSize: formComponents.optionalSpanFontSize,
    lineHeight: `${formComponents.input.height}px`,
    marginLeft: 6,
  },
  textarea: {},
  warning: {},
});

export default createUseStyles(styles);
